<ion-grid>
  <ion-row>
    <ion-col>
      <ion-card>
        <ion-card-header style="padding:0">
          <ion-toolbar color="primary">
            <ion-title>Importálás az aSc Órarend rendszerből</ion-title>
            <ion-buttons slot="end" *ngIf="step!=='upload'">
              <ion-button style="background: white; border-radius: 5px" [strong]="true" shape="round"
                color="secondary" size="small" (click)="ujImport()">
                <ion-icon slot="start" name="refresh"></ion-icon>Új import
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-card-header>

        <ion-card-content style="margin:15px;">

          <!-- ============ 1. LÉPÉS: FÁJL ============ -->
          <div *ngIf="step==='upload'">
            <p style="text-align: justify;">
              Töltsd fel az aSc Órarend rendszerből exportált <b>XML</b> adatbázist. A feltöltés után
              megjelenik egy előnézet, ahol a tanárokat összepárosíthatod az állományban szereplő
              munkatársakkal, és kiválaszthatod a betöltési időszakot és módot.
            </p>

            <div class="container" appDnd (fileDropped)="onFileDropped($event)">
              <input type="file" accept=".xml" #ascFileRef id="ascFileRef" (change)="onFileSelected($event)" />
              <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
                <g fill="#3B454F" fill-rule="nonzero">
                  <path d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
                  <path d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
                  <path d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
                </g>
              </svg>
              <h3>Húzza ide a fájlt (.xml)</h3>
              <h3 style="margin-bottom: 15px !important;">vagy</h3>
              <label for="ascFileRef">Tallózás</label>
            </div>

            <div *ngIf="file" class="single-file" style="display:flex;align-items:center;gap:10px;margin-top:10px;">
              <ion-icon name="document-text" style="font-size:28px;color:#3880ff"></ion-icon>
              <div class="info" style="flex:1">
                <h4 class="name" style="margin:0">{{ file?.name }}</h4>
              </div>
              <ion-button fill="clear" color="danger" (click)="clearFile()"><ion-icon slot="icon-only" name="trash"></ion-icon></ion-button>
            </div>

            <ion-button style="margin-top:15px" [strong]="true" expand="block" color="primary"
              [disabled]="!file || loading" (click)="uploadPreview()">
              <ion-icon slot="start" name="cloud-upload"></ion-icon>Feldolgozás és előnézet
            </ion-button>
          </div>

          <!-- ============ 2. LÉPÉS: ELŐNÉZET ============ -->
          <div *ngIf="step==='preview' && preview">

            <ion-grid class="ion-no-padding">
              <ion-row>
                <ion-col size="6" size-md="3"><ion-chip color="primary"><ion-icon name="book"></ion-icon><ion-label>{{preview.summary.subjects}} tantárgy</ion-label></ion-chip></ion-col>
                <ion-col size="6" size-md="3"><ion-chip color="primary"><ion-icon name="people"></ion-icon><ion-label>{{preview.summary.classes}} osztály</ion-label></ion-chip></ion-col>
                <ion-col size="6" size-md="3"><ion-chip color="primary"><ion-icon name="business"></ion-icon><ion-label>{{preview.summary.classrooms}} terem</ion-label></ion-chip></ion-col>
                <ion-col size="6" size-md="3"><ion-chip color="primary"><ion-icon name="grid"></ion-icon><ion-label>{{preview.summary.groups}} csoport</ion-label></ion-chip></ion-col>
                <ion-col size="6" size-md="3"><ion-chip color="primary"><ion-icon name="time"></ion-icon><ion-label>{{preview.summary.lessons}} óra</ion-label></ion-chip></ion-col>
                <ion-col size="6" size-md="3"><ion-chip color="primary"><ion-icon name="calendar"></ion-icon><ion-label>{{preview.summary.cards}} beosztás</ion-label></ion-chip></ion-col>
                <ion-col size="12" size-md="6"><ion-chip [color]="unmatchedCount? 'warning':'success'"><ion-icon name="person"></ion-icon><ion-label>{{matchedCount}}/{{preview.summary.teachers}} tanár párosítva</ion-label></ion-chip></ion-col>
              </ion-row>
            </ion-grid>

            <!-- Mit importáljunk a fájlból, és hogyan -->
            <h3 style="margin-top:15px">Mit importáljunk?</h3>
            <p style="color:#666;font-size:0.9em">
              Részenként eldöntheted, hozzányúljunk-e egyáltalán, és hogy a <b>kiegészítés</b>
              (csak a hiányzó jön létre, a meglévőhöz nem nyúlunk) vagy a <b>felülírás</b>
              (a meglévőt is a fájl szerintire igazítjuk) legyen az irányadó.
            </p>
            <div class="scrollable-table">
              <table style="width:100%;border-collapse:collapse;font-size:14px">
                <thead>
                  <tr style="background:#f2f4f8">
                    <th style="text-align:left;padding:6px">Rész</th>
                    <th style="text-align:left;padding:6px">A fájlban</th>
                    <th style="text-align:left;padding:6px">Mód</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let r of reszLista" style="border-bottom:1px solid #eee">
                    <td style="padding:6px">
                      <ion-checkbox labelPlacement="end" [(ngModel)]="reszek[r.kulcs].be">{{r.cim}}</ion-checkbox>
                      <div style="color:#888;font-size:12px;margin-left:30px">{{r.leiras}}</div>
                    </td>
                    <td style="padding:6px;white-space:nowrap">{{ reszDb(r.kulcs) }}</td>
                    <td style="padding:6px">
                      <ion-select *ngIf="r.kulcs !== 'tanar'" interface="popover" style="min-width:170px"
                        [(ngModel)]="reszek[r.kulcs].mod" [disabled]="!reszek[r.kulcs].be">
                        <ion-select-option value="kiegeszit">Kiegészítés</ion-select-option>
                        <ion-select-option value="felulir">{{ r.kulcs === 'orarend' ? 'Felülírás (időszak törlése)' : 'Felülírás' }}</ion-select-option>
                      </ion-select>
                      <small *ngIf="r.kulcs === 'tanar'" style="color:#888">párosítás mentése</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Tanév + opciók -->
            <ion-list lines="none">
              <ion-item>
                <ion-select label="Tanév" labelPlacement="stacked" interface="popover" [(ngModel)]="selectedEv">
                  <ion-select-option *ngFor="let t of tanevek" [value]="t.id">{{ t.name || t.id }}</ion-select-option>
                </ion-select>
              </ion-item>

              <ion-item>
                <ion-select label="Időszak" labelPlacement="stacked" interface="popover" [(ngModel)]="intervalType">
                  <ion-select-option value="egesz">Egész tanév</ion-select-option>
                  <ion-select-option value="elsofelev">1. félév</ion-select-option>
                  <ion-select-option value="masodikfelev">2. félév</ion-select-option>
                  <ion-select-option value="sajat">Egyéni intervallum</ion-select-option>
                </ion-select>
              </ion-item>
              <ion-grid *ngIf="intervalType==='sajat'">
                <ion-row>
                  <ion-col><ion-input label="Kezdő dátum" labelPlacement="stacked" fill="outline" type="date" [(ngModel)]="customStart"></ion-input></ion-col>
                  <ion-col><ion-input label="Záró dátum" labelPlacement="stacked" fill="outline" type="date" [(ngModel)]="customEnd"></ion-input></ion-col>
                </ion-row>
              </ion-grid>
              <small *ngIf="intervalType!=='sajat' && selectedTanev" style="padding:5px;color:#666">
                A heti órák a tanév táblából vett időszakra terülnek ki (hétvégék és ünnepnapok kihagyásával).
              </small>

              <ion-item lines="none" *ngIf="reszek.orarend.be">
                <ion-note color="medium" class="ion-text-wrap" style="font-size:.85em">
                  Az órarend módja fent, a részeknél állítható:
                  <b *ngIf="reszek.orarend.mod === 'felulir'">felülírás</b>
                  <b *ngIf="reszek.orarend.mod !== 'felulir'">kiegészítés</b> –
                  <span *ngIf="reszek.orarend.mod === 'felulir'">a kiválasztott időszak meglévő órái törlődnek, majd újratöltődnek.</span>
                  <span *ngIf="reszek.orarend.mod !== 'felulir'">csak a még nem szereplő órák jönnek létre.</span>
                </ion-note>
              </ion-item>
              <ion-item lines="none" *ngIf="!reszek.orarend.be">
                <ion-note color="warning" class="ion-text-wrap" style="font-size:.85em">
                  Az órarendet nem importáljuk: csak a bepipált törzsadat-részek frissülnek,
                  órarendi sor nem jön létre.
                </ion-note>
              </ion-item>
            </ion-list>

            <!-- Tanár párosító -->
            <h3 style="margin-top:15px">Tanárok párosítása az állománnyal</h3>
            <p style="color:#666;font-size:0.9em">
              A pirossal jelzett tanárokhoz rendelj állományi munkatársat, vagy hagyd „Kihagyás"-on – utóbbi
              esetben az adott tanár óráit nem importáljuk. Ha valaki még nincs az állományban, itt helyben
              létrehozható a KIR-kivonatból – nem kell kilépni az importból.
            </p>

            <!-- KIR-kivonat a hiányzó munkatársakhoz -->
            <div style="background:#f6f8fb;border-radius:8px;padding:10px;margin-bottom:12px"
                 *ngIf="parositatlanTanarok.length || kirSorok.length">
              <div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap">
                <b>KIR-kivonat betöltése</b>
                <input type="file" accept=".xlsx,.xls" (change)="onKirFile($event)">
                <span *ngIf="kirFajlNev" style="color:#2a7">{{kirFajlNev}} – {{kirSorok.length}} személy</span>
              </div>
              <small style="color:#666">
                Ugyanaz az Excel, amit az Állomány import vár (KIR-export). A betöltés után a rendszer
                névre javaslatot tesz a párosítatlan tanárokhoz; az e-mail cím a létrehozás előtt javítható.
              </small>

              <div *ngFor="let t of parositatlanTanarok" style="border-top:1px solid #e3e7ee;margin-top:8px;padding-top:8px"
                   [hidden]="!kirSorok.length">
                <div style="display:flex;gap:10px;flex-wrap:wrap;align-items:flex-end">
                  <div style="min-width:170px"><b>{{t.name}}</b><br><small style="color:#888">{{t.short}}</small></div>
                  <ion-select style="min-width:240px" fill="outline" label="KIR-személy" labelPlacement="stacked"
                    interface="popover" [ngModel]="kirValasztas[t.ascId]" (ngModelChange)="kirValt(t.ascId, $event)"
                    placeholder="Válassz a KIR-fájlból">
                    <ion-select-option *ngFor="let r of kirSorok" [value]="r">
                      {{ kirNev(r) }}{{ r['Munkakör'] ? ' – ' + r['Munkakör'] : '' }}
                    </ion-select-option>
                  </ion-select>
                  <ion-input style="min-width:230px" fill="outline" label="E-mail (javítható)" labelPlacement="stacked"
                    [(ngModel)]="kirEmail[t.ascId]" placeholder="nev@iskola.hu"></ion-input>
                  <ion-button size="small" color="success" (click)="kirLetrehoz(t)"
                    [disabled]="!kirValasztas[t.ascId] || kirFut[t.ascId]">
                    <ion-icon slot="start" name="person-add"></ion-icon>Létrehozás és párosítás
                  </ion-button>
                </div>
              </div>
            </div>
            <ion-list>
              <ion-item *ngFor="let t of preview.teachers"
                [color]="(teacherMap[t.ascId] && teacherMap[t.ascId]!=='__SKIP__') ? '' : 'danger'">
                <ion-label style="min-width:160px">
                  <b>{{ t.name }}</b>
                  <p *ngIf="t.short">{{ t.short }}</p>
                  <p *ngIf="t.letrehozva" style="color:#2a7">KIR-ből létrehozva</p>
                </ion-label>
                <ion-select slot="end" style="min-width:220px" interface="popover" labelPlacement="stacked"
                  [(ngModel)]="teacherMap[t.ascId]" placeholder="Válassz munkatársat">
                  <ion-select-option value="">— nincs —</ion-select-option>
                  <ion-select-option value="__SKIP__">Kihagyás (órák nélkül)</ion-select-option>
                  <ion-select-option *ngFor="let a of preview.allomany" [value]="a.adid">{{ a.nev }}</ion-select-option>
                </ion-select>
              </ion-item>
            </ion-list>

            <ion-button style="margin-top:15px" [strong]="true" expand="block" color="primary"
              [disabled]="loading" (click)="commit()">
              <ion-icon slot="start" name="checkmark-done"></ion-icon>{{ reszek.orarend.be ? 'Órarend és törzsadat importálása' : 'Kiválasztott részek importálása' }}
            </ion-button>
          </div>

          <!-- ============ 3. LÉPÉS: EREDMÉNY ============ -->
          <div *ngIf="step==='done' && result">
            <div style="text-align:center;padding:10px">
              <ion-icon name="checkmark-circle" style="font-size:64px;color:#2dd36f"></ion-icon>
              <h2>Sikeres importálás</h2>
            </div>
            <ion-list lines="full">
              <ion-item><ion-label>Időszak</ion-label><ion-note slot="end">{{result.interval.start}} – {{result.interval.end}}</ion-note></ion-item>
              <ion-item><ion-label>Órarend módja</ion-label>
                <ion-note slot="end">{{ result.interval.mode==='replace' ? 'Felülírás' : (result.interval.mode==='kihagy' ? 'Kihagyva' : 'Kiegészítés') }}</ion-note></ion-item>
              <ion-item *ngIf="result.reszek"><ion-label class="ion-text-wrap">Részek</ion-label>
                <ion-note slot="end" class="ion-text-wrap" style="text-align:right">
                  tantárgy: {{result.reszek.tantargy}}<br>osztály: {{result.reszek.osztaly}}<br>
                  terem: {{result.reszek.terem}}<br>tanár: {{result.reszek.tanar}}<br>
                  tanmenet: {{result.reszek.tanmenet}}<br>órarend: {{result.reszek.orarend}}
                </ion-note></ion-item>
              <ion-item *ngIf="result.kihagyott && kihagyottOsszes(result.kihagyott)" color="warning">
                <ion-label class="ion-text-wrap">
                  <b>Kikapcsolt rész miatt kihagyva:</b>
                  <p>{{result.kihagyott.tantargy}} tantárgy, {{result.kihagyott.osztaly}} osztály,
                     {{result.kihagyott.terem}} terem, {{result.kihagyott.csoport}} csoport,
                     {{result.kihagyott.ora}} óra</p>
                </ion-label>
              </ion-item>
              <ion-item><ion-label>Beszúrt órarendi sorok</ion-label><ion-note slot="end" color="success">{{result.inserted}}</ion-note></ion-item>
              <ion-item *ngIf="result.deleted"><ion-label>Törölt korábbi sorok</ion-label><ion-note slot="end" color="danger">{{result.deleted}}</ion-note></ion-item>
              <ion-item *ngIf="result.skippedDup"><ion-label>Kihagyott (már létező) sorok</ion-label><ion-note slot="end">{{result.skippedDup}}</ion-note></ion-item>
              <ion-item><ion-label>Létrehozott tantárgy / osztály / terem / csoport</ion-label>
                <ion-note slot="end">{{result.created.tantargy}} / {{result.created.osztaly}} / {{result.created.tanterem}} / {{result.created.csoport}}</ion-note></ion-item>
              <ion-item><ion-label>Létrehozott kerettanterv / csengetési rend</ion-label>
                <ion-note slot="end">{{result.created.kerettanterv}} / {{result.created.csengetes}}</ion-note></ion-item>
              <ion-item><ion-label>Kihagyott ünnepnapok</ion-label><ion-note slot="end">{{result.holidaysSkipped}}</ion-note></ion-item>
              <ion-item *ngIf="result.unmatchedTeacherLessons" color="warning">
                <ion-label class="ion-text-wrap">
                  <b>{{result.unmatchedTeacherLessons}} óra kihagyva</b> párosítatlan tanár miatt:
                  <p>{{ result.unmatchedTeacherNames.join(', ') }}</p>
                </ion-label>
              </ion-item>
            </ion-list>
            <ion-button style="margin-top:15px" expand="block" fill="outline" (click)="ujImport()">
              <ion-icon slot="start" name="refresh"></ion-icon>Új import indítása
            </ion-button>
          </div>

        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
